export { nextImageLoader as default } from "@soprisapps/components/utils/nextImageLoader";
